import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["width", "height", "value", "run"];
import React, { useEffect, useRef } from 'react';
import "./index.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var rotations = [0, 0, 0]; // [seconds, minutes, hours]

export default function Clock(props) {
  if (props === void 0) {
    props = {};
  }
  var {
      width = 140,
      height = 140,
      value,
      run = true
    } = props,
    svgProps = _objectWithoutPropertiesLoose(props, _excluded);
  var interval = useRef();
  var handHour = /*#__PURE__*/React.createRef();
  var handMinute = /*#__PURE__*/React.createRef();
  var handSecond = /*#__PURE__*/React.createRef();
  function handleTime() {
    var now = new Date(value || new Date());
    var seconds = now.getSeconds();
    var minutes = now.getMinutes();
    var hours = now.getHours() % 12;
    if (seconds === 0) {
      rotations[0] += 1;
    }
    if (minutes === 0 && seconds === 0) {
      rotations[1] += 1;
    }
    if (hours === 0 && minutes === 0 && seconds === 0) {
      rotations[2] += 1;
    }
    var secondsDeg = seconds / 60 * 360 + rotations[0] * 360;
    var minutesDeg = minutes / 60 * 360 + rotations[1] * 360;
    var hoursDeg = hours / 12 * 360 + minutes / 60 * 30 + rotations[2] * 360;
    if (handHour.current) {
      handHour.current.style.transform = "rotate(" + hoursDeg + "deg)";
    }
    if (handMinute.current) {
      handMinute.current.style.transform = "rotate(" + minutesDeg + "deg)";
    }
    if (handSecond.current) {
      handSecond.current.style.transform = "rotate(" + secondsDeg + "deg)";
    }
  }
  useEffect(() => {
    handleTime();
    if (run) {
      interval.current = setInterval(() => handleTime(), 1000);
    }
    return () => {
      if (interval.current) {
        clearInterval(interval.current);
        interval.current = undefined;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsxs("svg", _extends({
    className: "u-clock",
    viewBox: "0 0 100 100",
    color: "#212121",
    fill: "currentColor",
    width: width,
    height: height
  }, svgProps, {
    children: [/*#__PURE__*/_jsx("g", {
      className: "u-clock-marks",
      children: [...Array(12)].map((_, idx) => /*#__PURE__*/_jsx("line", {
        stroke: "currentColor",
        opacity: 0.7,
        strokeWidth: 1,
        transform: "rotate(" + 30 * idx + ")",
        strokeLinecap: "round",
        x1: "50",
        y1: "5",
        x2: "50",
        y2: "10"
      }, idx))
    }), /*#__PURE__*/_jsx("line", {
      ref: handHour,
      stroke: "currentColor",
      className: "u-clock-hour",
      strokeLinecap: "round",
      strokeWidth: "1.5",
      x1: "50",
      y1: "25",
      x2: "50",
      y2: "50"
    }), /*#__PURE__*/_jsx("line", {
      ref: handMinute,
      stroke: "currentColor",
      className: "u-clock-minute",
      strokeLinecap: "round",
      strokeWidth: "1.5",
      x1: "50",
      y1: "10",
      x2: "50",
      y2: "50"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "50",
      cy: "50",
      r: "3"
    }), /*#__PURE__*/_jsxs("g", {
      ref: handSecond,
      className: "u-clock-second",
      stroke: "currentColor",
      color: "#F44336",
      strokeWidth: "1",
      children: [/*#__PURE__*/_jsx("line", {
        x1: "50",
        y1: "10",
        x2: "50",
        y2: "60",
        strokeLinecap: "round"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "50",
        cy: "50",
        r: "1.5"
      })]
    })]
  }));
}